import React from 'react';
import { Section } from './Section';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <Section data-id="element-104">
      <div className="flex flex-col items-center text-center mb-8" data-id="element-105">
        <div className="bg-red-500/10 p-4 rounded-full mb-6" data-id="element-106">
          <AlertTriangle className="w-10 h-10 text-red-500" data-id="element-107" />
        </div>
        <h2 className="text-3xl md:text-5xl font-bold text-white uppercase mb-6" data-id="element-108">
          Estás atrapado en la{' '}
          <span className="text-red-500" data-id="element-109">"Falsa Productividad"</span>
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-6 text-lg md:text-xl text-zinc-400 leading-relaxed text-center" data-id="element-110">
        <p data-id="element-111">
          Pasas 10 horas frente a la pantalla saltando de una urgencia a otra,
          respondiendo mensajes que no generan ingresos y procastinando las
          tareas que realmente mueven la aguja.
        </p>
        <p data-id="element-112">
          A las 9 PM, el cortisol sube. Miras tu lista de tareas y sigue
          intacta. Te sientes culpable, sacrificas tiempo con tu familia para
          "adelantar" algo por la noche, y despiertas al día siguiente con la
          misma niebla mental.
        </p>
        <p className="text-white font-semibold border-t-4 border-red-500 pt-4 py-2 bg-tactical-light/50 px-6" data-id="element-113">
          Estás quemando combustible en punto muerto y lo sabes.
        </p>
      </div>
    </Section>;
}